import React from 'react'

import ProcessDocumentPromo from '../../../../assets/images/promo-process-document.png'

import './ProcessDocumentUpsell.scss'

export const ProcessDocumentUpsellBody: React.FC = () => {
  return (
    <>
      <img src={ProcessDocumentPromo} alt='Document intelligence promo' className='zocks-border-0.5 process-document-upsell-promo' />
      <div className='d-flex flex-column gap-1'>
        <h5>Turn documents into insights instantly</h5>
        <div className='paragraph-medium'>
          Upload any document and AI extracts financial changes, life events, and key updates, then syncs to your CRM and financial systems. Zero manual data
          entry.
        </div>
      </div>
    </>
  )
}

export const ProcessDocumentUpsellFeatures: React.FC = () => {
  return (
    <>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>AI-powered extraction</strong>: Automatically identifies account balances, transactions, portfolio changes from documents.
        </div>
      </div>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Sync-ready data</strong>: Extracted insights are ready to sync directly to your CRM and financial planning systems.
        </div>
      </div>
      <div className='d-flex gap-2 mb-3'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Custom templates</strong>: Configure what data to extract in what format for different document types to match your workflow.
        </div>
      </div>
    </>
  )
}
